import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const SafetyIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M11.3148 3.18792C11.7599 3.02444 12.2486 3.02444 12.6938 3.18792L19.029 5.5146C20.3686 6.00659 21.1762 7.3742 20.9601 8.78487L20.6532 10.7891C19.9871 15.138 17.1666 18.8549 13.1576 20.667L12.828 20.816C12.3044 21.0527 11.7042 21.0527 11.1805 20.816L10.8509 20.667C6.8419 18.8549 4.02144 15.138 3.35537 10.7891L3.0484 8.78487C2.83234 7.3742 3.63995 6.00659 4.97957 5.5146L11.3148 3.18792ZM12.0043 5.06531L5.66907 7.39199C5.22253 7.55599 4.95333 8.01186 5.02534 8.48208L5.33232 10.4863C5.89592 14.1662 8.28245 17.3112 11.6747 18.8446L12.0043 18.9935L12.3338 18.8446C15.7261 17.3112 18.1126 14.1662 18.6762 10.4863L18.9832 8.48208C19.0552 8.01186 18.786 7.55599 18.3395 7.39199L12.0043 5.06531ZM15.7558 8.58325C16.1538 8.96617 16.166 9.59922 15.7831 9.9972L11.8456 14.0895C11.6571 14.2854 11.3969 14.3961 11.125 14.3961C10.8531 14.3961 10.5929 14.2854 10.4044 14.0895L8.6544 12.2707C8.27147 11.8727 8.28367 11.2397 8.68164 10.8567C9.07962 10.4738 9.71266 10.486 10.0956 10.884L11.125 11.9538L14.3419 8.6105C14.7248 8.21252 15.3579 8.20032 15.7558 8.58325Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

SafetyIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(SafetyIcon);
